export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11160.5b1c6b0c.jpg";